export default class AccountFile {
    constructor() {
        this.id;
        this.accountId;
        this.fileId;
        this.accountFileType;
        this.validUntil;
        this.isVerified;
        this.verifiedByUserId;
        this.verfiedByUser;
    }

    set(setEntity) {
        this.id = setEntity.id;
        this.accountId = setEntity.accountId;
        this.fileId = setEntity.fileId;
        this.accountFileType = setEntity.accountFileType;
        this.validUntil = setEntity.validUntil;
        this.isVerified = setEntity.isVerified;
        this.verifiedByUserId = setEntity.verifiedByUserId;
        this.verfiedByUser = setEntity.verfiedByUser;
        return this;
    }
}
